import { render, staticRenderFns } from "./batteryIndex.vue?vue&type=template&id=180e82a0&scoped=true"
import script from "./batteryIndex.vue?vue&type=script&lang=js"
export * from "./batteryIndex.vue?vue&type=script&lang=js"
import style0 from "./batteryIndex.vue?vue&type=style&index=0&id=180e82a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180e82a0",
  null
  
)

export default component.exports